<app-main-menu class="main-navigation"></app-main-menu>

<main class="main-content" [class.darkmode]="darkMode()">
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
</main>
